import { createRef, Component, RefObject } from 'react';
import { NamingConvention } from 'namirasoft-core';
import { NSARouterMakerResult } from 'namirasoft-account-react';
import { AccountRouterProps } from "../AccountRouterProps";
import { NSBox, NSBoxBooleans, NSButtonBlue, NSPanel, NSRow, NSSection, NSSpace, NSSpaceSizeType, NSTitle } from 'namirasoft-site-react';
import { AccountLayout } from '../AccountLayout';

interface NotificationSettingPageProps extends NSARouterMakerResult, AccountRouterProps { }

interface NotificationSettingPageState
{
	notifications: { [group: string]: string[]; };
}
class NotificationSettingPage extends Component<NotificationSettingPageProps, NotificationSettingPageState>
{
	NSBoxBooleans_Notifications: { [group: string]: RefObject<NSBoxBooleans>; } = {};

	constructor(props: NotificationSettingPageProps)
	{
		super(props);
		this.state = { notifications: {} };
		this.onApply = this.onApply.bind(this);
	}
	override componentDidMount()
	{
		this.props.account.server.notification_setting.List().then((notifications: { [group: string]: string[]; }) =>
		{
			let groups = Object.keys(notifications);
			groups.forEach(group => this.NSBoxBooleans_Notifications[group] = createRef<NSBoxBooleans>());

			this.setState({ notifications }, () =>
			{
				let value = this.props.account.token_manager.get()?.user?.notification_setting;
				if (value)
				{
					let checked = JSON.parse(value);
					if (checked)
					{
						Object.keys(this.state.notifications).forEach(group =>
						{
							let values = ((checked[group] as string[]) ?? []).filter(e => e).map(e => e as string);
							this.NSBoxBooleans_Notifications[group].current?.setValues(values);
						});
					}
				}
			});
		}).catch(() => { });
	}

	onApply(onFinished: () => void)
	{
		try
		{
			let groups = Object.keys(this.state.notifications);
			let notification: { [group: string]: string[]; } = {};
			groups.forEach(group => notification[group] = this.NSBoxBooleans_Notifications[group].current?.getValues() ?? []);
			this.props.account.server.notification_setting.Set(notification).then(() =>
			{
				this.props.notifier.onSuccess("Your notification preferences have been updated successfully.");
				onFinished();
			}).catch(onFinished);
		} catch (error)
		{
			this.props.notifier.onError(error as Error);
			onFinished();
		}
	}

	getInfoLink(item: string | null)
	{
		if (!item)
			return "";

		let base = "https://namirasoft.com/account/console-guide/notification-settings/#field-";
		return base + NamingConvention.auto.convert(item, NamingConvention.lower_case_dash);
	}

	override render()
	{
		let groups = Object.keys(this.state.notifications);
		return (
			<AccountLayout {...this.props}
				action={{
					title: "Notification Setting",
					description: "Customize your notification preferences. Set for what activities you want to receive messages.",
					menus: {}
				}}
			>
				<NSSection>
					{
						groups.map(group => (
							<>
								<NSPanel>
									<NSTitle title={NamingConvention.auto.convert(group, NamingConvention.Pascal_Case_Space)} style={{ color: "rgba(20, 27, 92, 1)", marginBottom: "0" }} />
									<NSRow style={{ maxWidth: NSBox.width.triple }}>
										<NSBoxBooleans
											ref={this.NSBoxBooleans_Notifications[group]}
											box_all={{
												hideHeader: true
											}}
											items={
												this.state.notifications[group].map((item: string | null) => 
												{
													return {
														value: item ?? "",
														text: NamingConvention.auto.convert(item ?? "", NamingConvention.Pascal_Case_Space),
														info: { link: this.getInfoLink(item) }
													};
												})
											}
											reverse
										/>
									</NSRow>
								</NSPanel>
								<NSSpace size={NSSpaceSizeType.NORMAL} />
							</>
						))
					}
					<NSButtonBlue
						title='Apply'
						onClick={{
							action: (onFinished) =>
							{
								this.onApply(onFinished);
							}
						}}
					/>
				</NSSection>
			</AccountLayout>
		);
	}
}

export default NotificationSettingPage;